import { render } from "./EnterConfirmationCode.vue?vue&type=template&id=cb7dabd8&scoped=true"
import script from "./EnterConfirmationCode.vue?vue&type=script&lang=js"
export * from "./EnterConfirmationCode.vue?vue&type=script&lang=js"

import "./EnterConfirmationCode.vue?vue&type=style&index=0&id=cb7dabd8&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps-v2/packages/frontendscanning/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7dabd8"]])

export default __exports__